import type { Board as BoardType } from "../api/gameData";
import { Cell } from "./Cell";

interface BoardProps {
  board: BoardType;
  winningLine: number[] | null;
  onCellClick: (index: number) => void;
  disabled: boolean;
}

export function Board({ board, winningLine, onCellClick, disabled }: BoardProps) {
  return (
    <div
      className="grid grid-cols-3 w-full max-w-[340px] sm:max-w-[400px] mx-auto rounded-2xl overflow-hidden"
      style={{
        backgroundColor: "var(--game-surface)",
        boxShadow: "0 0 80px -20px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.03)",
        animation: "fadeIn 0.4s ease-out",
      }}
      role="grid"
      aria-label="Tic Tac Toe board"
    >
      {board.map((cell, i) => (
        <Cell
          key={i}
          value={cell}
          index={i}
          onClick={onCellClick}
          isWinning={winningLine?.includes(i) ?? false}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
